export type LocationResult = {
  gps: { latitude: number; longitude: number; accuracyMeters: number | null } | null;
  gpsUnavailable: boolean;
};

export function captureLocation(): Promise<LocationResult> {
  if (!("geolocation" in navigator)) return Promise.resolve({ gps: null, gpsUnavailable: true });
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        gps: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracyMeters: Number.isFinite(position.coords.accuracy) ? position.coords.accuracy : null,
        },
        gpsUnavailable: false,
      }),
      () => resolve({ gps: null, gpsUnavailable: true }),
      { enableHighAccuracy: true, timeout: 8_000, maximumAge: 30_000 },
    );
  });
}
